module.exports = __webpack_public_path__ + "static/media/YM50_2.23935a9e.jpg";